import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";
import { SportDisciplineList } from "../components/SportDisciplineList";
import { sportCategories } from "../content/siteContent";

export function SportPage() {
  return (
    <PageFrame
      className="sport-page"
      label="ΑΣΟ ΩΜΕΓΑ · ISSF / ΣΚΟΕ"
      title="Το Άθλημα"
      intro={
        <p>
          Τα αγωνίσματα της σκοποβολής διεξάγονται σύμφωνα με τους διεθνείς κανονισμούς της ISSF, τους οποίους εφαρμόζει στη χώρα μας η Σκοπευτική Ομοσπονδία Ελλάδος (ΣΚΟΕ).
        </p>
      }
    >
      <Reveal className="sport-introduction technical-frame">
        <p>
          Ορισμένα από αυτά περιλαμβάνονται στο πρόγραμμα των Ολυμπιακών Αγώνων, ενώ τα υπόλοιπα διεξάγονται σε Παγκόσμια και Ευρωπαϊκά Πρωταθλήματα, καθώς και σε εθνικό επίπεδο.
        </p>
        <p>
          Στα αγωνίσματα σταθερού στόχου, ο στόχος είναι σταθερά τοποθετημένος σε διαφορετική απόσταση ανάλογα με το αγώνισμα. Οι στόχοι είναι κατά κανόνα χάρτινοι, ενώ στους σύγχρονους αγώνες χρησιμοποιούνται όλο και περισσότερο ηλεκτρονικά συστήματα βαθμολόγησης (EST).
        </p>
        <strong>Στον Όμιλό μας προπονούμαστε στα παρακάτω αγωνίσματα.</strong>
      </Reveal>

      <div className="sport-categories">
        {sportCategories.map((category) => (
          <Reveal className="sport-category-frame technical-frame" key={category.title}>
            <SportDisciplineList category={category} />
          </Reveal>
        ))}
      </div>

      <Reveal className="sport-cta technical-frame">
        <div>
          <p className="technical-label">ΑΣΟ ΩΜΕΓΑ</p>
          <h2>Θέλετε να ξεκινήσετε;</h2>
          <p>Βρείτε όλες τις αιτήσεις και τα έγγραφα του Ομίλου σε ένα σημείο.</p>
        </div>
        <Link className="button button--primary" to="/eggrafa" data-target>
          Δείτε τα έγγραφα
          <ArrowRight aria-hidden="true" />
        </Link>
      </Reveal>
    </PageFrame>
  );
}
